import { useContext, useEffect, useState } from "react";
import L from "leaflet";
import { UserContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { format, isAfter, parse } from "date-fns";

const MapaDePuntos = (props) => {
  const { camaras, setCamaras } = props;
  const { actions: ua } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { handlerModal } = useGeneralAppStore();
  useEffect(() => {
    const buildMap = async () => {
      if (!camaras.data) {
        return;
      }

      let container = L.DomUtil.get("map");
      if (container != null) {
        container._leaflet_id = null;
      }

      let map = L.map("map", { attributionControl: false }).setView(
        [-38.950430771322864, -68.07870462416368],
        13
      );
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        minZoom: 11,
        maxZoom: 20,
      }).addTo(map);

      camaras.data.forEach((camara) => {
        let cantidad = camara.infracciones_count;
        let ocultarCamara = false;
        if (camara.fecha_colocacion && camaras?.fecha_fin) {
          if (isAfter(format(parse(camara.fecha_colocacion, "dd/MM/yyyy HH:mm", new Date()), "yyyy-MM-dd"), format(camaras?.fecha_fin + " 23:59:59", 'yyyy-MM-dd'))) {
            ocultarCamara = true;
          }
        }
        if (!ocultarCamara && camara.latitud && camara.longitud) {
          let lengthCantidad = cantidad.toString().length;
          let iconAnchor;
          if (lengthCantidad > 2) {
            iconAnchor = (lengthCantidad * 11) / 2;
          } else if (lengthCantidad === 2) {
            iconAnchor = 13;
          } else if (lengthCantidad === 1) {
            iconAnchor = 9;
          }

          let color = cantidad === 0 ? "danger" : "success";

          L.marker([camara.latitud, camara.longitud], {
            icon: L.divIcon({
              className: "custom-div-icon",
              html: `
            <div class="marker" style="
            font-family: Arial, Helvetica, sans-serif;
            font-weight: 900; 
            background-color: var(--${color}); 
            opacity: 1; 
            // border: 1px solid #FFF;
            border-radius: 0.375rem; 
            color: #FFF; 
            padding: 2px 5px;              
            display: inline-block;      
                text-align: center;         
                white-space: nowrap;        
                max-width: 100px;           
                ">
                ${cantidad}
                </div>
                `,
              iconSize: [0, 20],
              iconAnchor: [iconAnchor, 10],
            }),
          })
            .addTo(map)
            .bindTooltip(
              `<p style="font-size: .9rem; font-weight:bolder; margin-bottom: 0px;">
          Lugar: ${camara.lugar}
          <br/>
          Cámara: ${camara.numero_serie}
          <br/>
          Cantidad: ${cantidad} 
          </p>`,
              {
                permanent: false,
                direction: "top",
                offset: [0, -10],
              }
            )
            .on("click", () => {
              setCamaras((prevState) => ({
                ...prevState,
                camara_seleccionada: camara,
              }));
              handlerModal({ modal: true, modalName: "info_camara" });
              // console.log(camara);
            });
        }
      });

      // return () => map.remove();
      setIsLoading(false);
    };

    if (ua.hasPermission("camaras.view.general")) {
      setIsLoading(true);
      buildMap();
    } else {
      navigate("/");
    }
  }, []);

  return (
    <div>
      {/* <h2 className="text-decoration-underline mb-3">Mapa de puntos</h2> */}
      <div id="map" style={{ height: "89vh" }}>
        {isLoading ? <div className=""></div> : null}
      </div>
    </div>
  );
};

export default MapaDePuntos;
